import { Link } from "react-router-dom";
import { Headphones, Blocks, Music2, Zap, Shuffle, BookMarked, Layers, Scissors } from "lucide-react";

const GAMES = [
    { id: "letter-sound", title: "Letter & Sound", desc: "Match each letter to the sound it makes.", icon: Headphones, color: "#2D5D4E", bg: "#E0EDE6" },
    { id: "blending", title: "Blending", desc: "Slide three sounds together into a real word.", icon: Layers, color: "#1F4237", bg: "#E0EDE6" },
    { id: "segmenting", title: "Segmenting", desc: "Hear a word, then pull it apart into its sounds.", icon: Scissors, color: "#B86644", bg: "#FDE9DD" },
    { id: "word-build", title: "Word Builder", desc: "Pick the right letters to spell each word.", icon: Blocks, color: "#D47A55", bg: "#FDE9DD" },
    { id: "rhyme", title: "Rhyme Match", desc: "Find which word rhymes.", icon: Music2, color: "#1F4237", bg: "#E8E2D2" },
    { id: "sight-words", title: "Sight Words Sprint", desc: "How many common words can you read in 60 seconds?", icon: Zap, color: "#B86644", bg: "#FDE9DD" },
    { id: "unscramble", title: "Sentence Unscramble", desc: "Put the words in the right order.", icon: Shuffle, color: "#2D5D4E", bg: "#E0EDE6" },
    { id: "comprehension", title: "Read & Understand", desc: "Read a short story, then answer.", icon: BookMarked, color: "#1F4237", bg: "#E8E2D2" },
];

export default function Games() {
    return (
        <main className="container-page py-12 fade-up">
            <p className="label-eyebrow mb-2">Practice</p>
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-3" style={{ fontFamily: "Outfit" }} data-testid="games-title">
                Eight games. Five minutes. Real progress.
            </h1>
            <p className="text-lg text-[#515B57] max-w-2xl mb-10">
                Short, tactile games that turn what you've learned into something automatic.
            </p>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 stagger">
                {GAMES.map((g) => (
                    <Link
                        key={g.id}
                        to={`/app/games/${g.id}`}
                        data-testid={`game-card-${g.id}`}
                        className="card-rw p-7 hover:-translate-y-1"
                    >
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-5" style={{ background: g.bg }}>
                            <g.icon className="w-6 h-6" style={{ color: g.color }} strokeWidth={1.6} />
                        </div>
                        <h3 className="text-xl font-medium mb-2" style={{ fontFamily: "Outfit" }}>{g.title}</h3>
                        <p className="text-[#515B57] leading-relaxed">{g.desc}</p>
                    </Link>
                ))}
            </div>
        </main>
    );
}
